



















import { computed, defineComponent, onMounted, ref } from '@vue/composition-api'
import AtomInputText from '@/components/atoms/input/AtomInputText.vue'
import FormErrorMessageParts from '@/components/common/form/FormErrorMessageParts.vue'
import DeviceInfo from '@/util/DeviceInfo'

/**
 * フィールドセット 郵便番号入力 バーツ
 */
export default defineComponent({
  name: 'FieldsetZipcodeParts',
  components: {
    AtomInputText,
    FormErrorMessageParts,
  },
  props: {
    /**
     * 入力データ
     */
    value: {
      type: String,
      default: '',
    },
    /**
     * 必須フラグ
     */
    required: {
      type: Boolean,
      default: false,
    },
    /**
     * エラーフラグ
     */
    showError: {
      type: Boolean,
      default: false,
    },
    /**
     * エラーメッセージ
     */
    errorMessage: {
      type: String,
      default: '',
    },
  },
  setup(props, context) {
    /**
     * 郵便番号入力フォームの変更が可能かどうか
     * ブラウザの場合にisDisabled: trueにする
     */
    const isDisabled = ref(!DeviceInfo.isCordova())

    /**
     * zipcode
     * @param {string} val 郵便番号
     */
    const zipcode = computed({
      get: () => props.value,
      set: (val: string) => context.emit('input', val),
    })

    onMounted(async () => {
      /**
       * Chromeのブラウザだと郵便番号入力フォームが認証情報と誤認されてしまう。
       * そのため、DOM生成時はdisabled状態とすることでChromeに認識させないようにし、0.5秒後に入力可能な状態にすることで対処している。
       */
      await new Promise((resolve) => {
        setTimeout(resolve, 500)
      })
      isDisabled.value = false
    })

    return {
      zipcode,
      isDisabled,
    }
  },
  methods: {
    /**
     * Enter Push
     */
    emitEnter() {
      /**
       * Enterボタン押下を通知する
       * @event login
       * @type {Object}
       */
      this.$emit('enter')
    },
  },
})
